export default {
  // Node type descriptions
  expandNode: "This is an expansion node",

  // Tag related
  tags: "Tags",

  // Platform related
  platform: "Platform",
  analysisId: "Analysis ID",
  userId: "User ID",
  deviceId: "Device ID",

  // Wallet platform names
  bitpieWallet: "Bitpie Wallet",
  imToken: "imToken",

  // Field labels
  exchangeName: "Exchange Name",
  bankCardNumber: "Bank Card Number",
  username: "Username",
  userIdField: "User ID",
  phoneNumber: "Phone Number",
  surveyUser: "Survey User",

  // Statistical information in comments (reserved for future possible display)
  inflowCount: "Inflow Count",
  outflowCount: "Outflow Count",
  usdtInflowAvgQuantity: "USDT Inflow Average Quantity",
  usdtInflowOpponentCount: "USDT Inflow Opponent Count",
  usdtInflowTotalQuantity: "USDT Inflow Total Quantity",
  usdtOutflowAvgQuantity: "USDT Outflow Average Quantity",
  usdtOutflowOpponentCount: "USDT Outflow Opponent Count",
  usdtOutflowTotalQuantity: "USDT Outflow Total Quantity",
};
